import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from '~/player/router'
import App from '~/player/App.vue'
import { useAuthStore } from '~/player/stores/auth'
import './player.css'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(router)

const auth = useAuthStore()
auth.captureTokenFromUrl().finally(async () => {
  // 兌換完才掛載，避免 guard 早於 token 寫入
  await router.isReady()
  if (auth.isAuthenticated && router.currentRoute.value.meta.guest) {
    await router.replace('/')
  }
  app.mount('#app')
})
